import { render } from "./adjust-orders-modal.vue?vue&type=template&id=58f32cae"
import script from "./adjust-orders-modal.vue?vue&type=script&lang=js"
export * from "./adjust-orders-modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__